import { LoadingButton } from '@mui/lab';
import React, { useContext } from 'react';
import { SnackbarContext } from '../../../Providers/SnackbarProvider';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Error } from '@mui/icons-material';
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { EpisodeData } from '../types';
import { graphql } from 'gql';
import { namedOperations } from 'gql/graphql';

export const CascadeDeleteEpisode = graphql(`
    mutation CascadeDeleteEpisode($episodeId: ID!) {
        cascadeDeleteEpisode(episodeId: $episodeId) {
            nodesDeleted
            relationshipsDeleted
        }
    }`);

type Props = {
    open: boolean;
    onClose: () => void;
    episode: EpisodeData
}

export default function DeleteEpisodeDialog({ open, onClose, episode }: Props) {
    const navigate = useNavigate();

    const { success, error } = useContext(SnackbarContext);

    const [deleteEpisode, { loading }] = useMutation(CascadeDeleteEpisode);

    const handleYes = async () => {
        try {
            await deleteEpisode({
                variables: { episodeId: episode.id },
                refetchQueries: [
                    namedOperations.Query.GetEpisodesForSeason_Layout,
                    namedOperations.Query.EpisodeLines,
                ],
            });
            onClose();
            navigate('/');
            success('Episode deleted');
        } catch (e) {
            // @ts-ignore
            error('Failed to delete show. ' + e.message);
        }
    }

    if (!episode) {
        return null;
    }

    return (
        <Dialog open={open}>
            <DialogTitle>Delete Episode</DialogTitle>
            <DialogContent>
                <Typography>Are you sure you want to delete the episode {episode.title}?</Typography>
                <Typography color='error' variant='caption'>It will be gone forever!</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant='text' color='inherit'>No</Button>
                <LoadingButton
                    onClick={handleYes}
                    startIcon={<Error />}
                    variant='text'
                    color='error'
                    loading={loading}
                >
                    Yes
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}